import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const ArrowsDownUpIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill={color}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 4C8.55228 4 9 4.44772 9 5V16.5858L10.2929 15.2929C10.6834 14.9024 11.3166 14.9024 11.7071 15.2929C12.0976 15.6834 12.0976 16.3166 11.7071 16.7071L8.70711 19.7071C8.31658 20.0976 7.68342 20.0976 7.29289 19.7071L4.29289 16.7071C3.90237 16.3166 3.90237 15.6834 4.29289 15.2929C4.68342 14.9024 5.31658 14.9024 5.70711 15.2929L7 16.5858V5C7 4.44772 7.44772 4 8 4ZM15.2929 4.29289C15.6834 3.90237 16.3166 3.90237 16.7071 4.29289L19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711C19.3166 9.09763 18.6834 9.09763 18.2929 8.70711L17 7.41421V19C17 19.5523 16.5523 20 16 20C15.4477 20 15 19.5523 15 19V7.41421L13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289L15.2929 4.29289Z'
        fill={color}
      />
    </svg>
  )
})
